import {
    Component,
    EventEmitter,
    Input,
    Output,
    ChangeDetectionStrategy,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

/**
 * Component for navigation within the Go overview steps.
 */
@Component({
    selector: 'app-go-overview-navigation',
    imports: [MatButtonModule, MatIconModule],
    changeDetection: ChangeDetectionStrategy.Eager,
    templateUrl: './go-overview-navigation.component.html',
})
export class GoOverviewNavigationComponent {
    @Input() step!: number;
    @Input() initialStep!: number;
    @Input() stepRange!: number[];

    @Output() stepChange = new EventEmitter();

    onButtonClick() {
        this.stepChange.emit();
    }

    getInitialStep(): number {
        return this.initialStep;
    }

    getLastStep(): number {
        return this.stepRange[this.stepRange.length - 1];
    }
}
